import { Row, Col, Button, Badge } from 'reactstrap'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { useDispatch } from 'react-redux'
import { removeAllContacts } from '@src/views/apps/contacts/store/actions'
import { useHistory } from 'react-router-dom'

const mapStateToProps = (state) => {
  const { contacts } = state
  return {
    selectedContacts: contacts.selectedContacts,
    totalSelectedContacts: contacts.totalSelectedContacts
  }
}

const FooterContacts = (props) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { totalSelectedContacts } = props

  const handleDelete = () => {
    dispatch(removeAllContacts())
  }

  const handleSend = () => {
    history.push('/brands/packages')
  }

  return (
    <footer className="tw-fixed tw-inset-x-0 tw-bottom-20 tw-mx-auto tw-w-1/4 tw-p-4 tw-bg-white tw-shadow-lg tw-rounded-md tw-flex tw-items-center tw-justify-center">
      <Row>
        <Col>
          <div
            className={classnames('d-flex align-items-center')}
            style={{ gap: '1rem' }}
          >
            <>
              <Badge color="primary" className="badge-glow" size="lg">
                {totalSelectedContacts}
              </Badge>
              <strong>contato(s) selecionado(s)</strong>
            </>
          </div>
          <div className="tw-flex tw-mt-1 tw-items-center tw-w-full tw-flex-1 tw-justify-center">
            <Button.Ripple
              color="flat-primary"
              size="sm"
              onClick={handleDelete}
            >
              Limpar seleção
            </Button.Ripple>

            <Button.Ripple
              color="primary"
              size="sm"
              className="tw-ml-1"
              onClick={handleSend}
            >
              Fazer envio
            </Button.Ripple>
          </div>
        </Col>
      </Row>
    </footer>
  )
}

export default connect(mapStateToProps)(FooterContacts)
